import { render, staticRenderFns } from "./LocationMailSettings.vue?vue&type=template&id=109b512a"
import script from "./LocationMailSettings.vue?vue&type=script&lang=js"
export * from "./LocationMailSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports